export { schoolTypeTranslates } from './school-type-translates';
export { studentsAddModeTranslates, studentsAddModeOptions } from './students-add-mode';
